import { render } from "./CommonExpense.vue?vue&type=template&id=ff281c70"
import script from "./CommonExpense.vue?vue&type=script&lang=js"
export * from "./CommonExpense.vue?vue&type=script&lang=js"
script.render = render

export default script